export const SET_RESPONSE_CONTEXT = 'teamly/settings/SET_RESPONSE_CONTEXT';

export default (state = [{ responseContext: '' }], action: any) => {
  switch (action.type) {
    case SET_RESPONSE_CONTEXT:
      const { responseContext } = action;
      return {
        ...state,
        responseContext,
      };
    default:
      return state;
  }
};

export const setResponseContext = (responseContext: any) => ({
  type: SET_RESPONSE_CONTEXT,
  responseContext,
});
